<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Vehicle category - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="category">Category</label>
                <input type="text" 
                class="form-control" 
                id="category" 
                placeholder="Category"
                v-model="category">
                <div class="invalid-feedback" v-if="errors.category">{{ errors.category[0] }}</div>
            </div>
            <div class="form-group">
                <label for="fuelFlatRate">Fuel flat rate</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="fuelFlatRate" 
                placeholder="Fuel flat rate"
                v-model="fuelFlatRate">
                <div class="invalid-feedback" v-if="errors.fuelFlatRate">{{ errors.fuelFlatRate[0] }}</div>
            </div>
             <div class="form-group">
                <label for="unleadedPetrolCostPerKM">Unleaded petrol cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="unleadedPetrolCostPerKM" 
                placeholder="Unleaded petrol cost/Km"
                v-model="unleadedPetrolCostPerKM">
                <div class="invalid-feedback" v-if="errors.unleadedPetrolCostPerKM">{{ errors.unleadedPetrolCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="premiumUnleadedCostPerKM">Premium unleaded cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="premiumUnleadedCostPerKM" 
                placeholder="Premium unleaded cost/Km"
                v-model="premiumUnleadedCostPerKM">
                <div class="invalid-feedback" v-if="errors.premiumUnleadedCostPerKM">{{ errors.premiumUnleadedCostPerKM[0] }}</div>
            </div>
             <div class="form-group">
                <label for="dieselCostPerKM">Diesel cost/KM</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="dieselCostPerKM" 
                placeholder="Diesel cost/Km"
                v-model="dieselCostPerKM">
                <div class="invalid-feedback" v-if="errors.dieselCostPerKM">{{ errors.dieselCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="tyresCostPerKM">Tyres cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="tyresCostPerKM" 
                placeholder="Tyres cost/Km"
                v-model="tyresCostPerKM">
                <div class="invalid-feedback" v-if="errors.tyresCostPerKM">{{ errors.tyresCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="serviceCostPerKM">Maintenance cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="serviceCostPerKM" 
                placeholder="Maintenance cost/Km"
                v-model="serviceCostPerKM">
                <div class="invalid-feedback" v-if="errors.serviceCostPerKM">{{ errors.serviceCostPerKM[0] }}</div>
            </div>


            
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as vehicleCategoryService from '../../services/vehicleCategory.service';
    export default {
        name:"ModalVehicleCategoryNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                category:'',
                fuelFlatRate:'',
                unleadedPetrolCostPerKM:'',
                premiumUnleadedCostPerKM:'',
                dieselCostPerKM:'',
                tyresCostPerKM:'',
                serviceCostPerKM:'',
            }
        },
        methods:{
            ...mapActions(['fetchVehicleCategoryAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('category',this.category);
                formData.append('fuelFlatRate',this.fuelFlatRate);
                formData.append('unleadedPetrolCostPerKM',this.unleadedPetrolCostPerKM);
                formData.append('premiumUnleadedCostPerKM',this.premiumUnleadedCostPerKM);
                formData.append('dieselCostPerKM',this.dieselCostPerKM);
                formData.append('tyresCostPerKM',this.tyresCostPerKM);
                formData.append('serviceCostPerKM',this.serviceCostPerKM);
            try{
                await vehicleCategoryService.add(formData);
                this.hideModal();
                this.fetchVehicleCategoryAll();

                messageService.fnSweetAlertSuccessToast('Vehicle category - new', 'added successfully');

                this.category = '';
                this.fuelFlatRate = '';
                this.unleadedPetrolCostPerKM = '';
                this.premiumUnleadedCostPerKM = '';
                this.tyresCostPerKM = '';
                this.maintenanceCostPerKm = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Vehicle category - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Vehicle category - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>